<template>
  <div class="px-2 d-flex justify-content-between align-items-center w-100 h-100">
    <div
      class="brand-logo mr-1 cursor-pointer"
      @click="onLogoClick"
    >
      <b-img
        id="logo"
        :src="echopeLogo"
        alt="logo"
        fluid
        class="rounded"
      />
    </div>

    <!-- Informações do cliente identificado -->
    <div
      v-if="hasCustomerIdentified"
      class="customer-info d-flex flex-column align-items-center justify-content-center"
    >
      <p class="mb-0 h4 text-light font-weight-bold">
        {{ customerDisplayText }}
      </p>
      <!-- Saldo de recompensas -->
      <div
        v-if="hasRewardBalance"
        class="reward-balance d-flex align-items-center justify-content-center mt-1"
      >
        <img
          :src="ecashCoin"
          alt="ecash"
          class="ecash-icon"
        >
        <span class="ml-1 h5 mb-0 text-success font-weight-bold">
          Saldo ecash: {{ formatRewardBalance(rewardBalance) }}
        </span>
      </div>
    </div>

    <div class="cart-section">
      <div
        class="d-flex cursor-pointer justify-content-end align-items-center"
        style="gap: 20px"
        @click="onShowCartSidebar"
      >
        <div class="position-relative">
          <b-icon
            class="h2"
            icon="cart"
            style="color: var(--theme-color)"
          />

          <b-badge
            v-if="getCartItemsQuantity > 0"
            class="position-absolute"
            style="top: -10px; right: -15px"
            variant="danger"
          >
            {{ getCartItemsQuantity }}
          </b-badge>
        </div>
        <p class="mb-0 h2 text-light text-right">
          {{ getTotalSale | currency }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { app } from '@/mixins'
import { BBadge, BIcon, BImg } from 'bootstrap-vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import echopeLogo from '@/assets/images/logo/echope_horizontal_large.png'
import ecashCoin from '@/assets/images/logo/ecash_moeda.png'
import { getInitialAtmCatalogFilters } from '@/store/pages/pdv/atm/atm-catalog'

export default {
  components: {
    BImg,
    BIcon,
    BBadge,
  },

  mixins: [app],

  data() {
    return {
      echopeLogo,
      ecashCoin,
    }
  },

  computed: {
    ...mapGetters('pages/pdv/payBox', [
      'getItems',
      'getTotalSale',
      'getCartItemsQuantity',
      'getCustomerDocument',
      'getCustomerName',
    ]),
    ...mapState('pages/pdv/payBox', {
      clientForm: 'clientForm',
    }),
    ...mapState('reward', {
      rewardBalance: 'rewardBalance',
    }),
    ...mapGetters('reward', ['hasRewardBalance', 'formatRewardBalance']),

    hasCustomerIdentified() {
      return this.getCustomerDocument && this.getCustomerDocument.trim() !== ''
    },

    customerDisplayText() {
      if (!this.hasCustomerIdentified) {
        return ''
      }

      // Se tem nome, mostra "Olá, [primeiro nome]!"
      if (this.getCustomerName && this.getCustomerName.trim() !== '') {
        const firstName = this.getCustomerName.trim().split(' ')[0]
        return `Olá, ${firstName}!`
      }

      // Se não tem nome, mostra CPF mascarado
      const document = this.getCustomerDocument.replace(/\D/g, '')
      if (document.length === 11) {
        // CPF: 293******03
        return `Cliente: ${document.substring(0, 3)}******${document.substring(9)}`
      }
      if (document.length === 14) {
        // CNPJ: 12.345****/0001-**
        return `Empresa: ${document.substring(0, 5)}****/${document.substring(8, 12)}-**`
      }

      return `Cliente: ${this.getCustomerDocument}`
    },
  },

  watch: {
    'clientForm.id': {
      immediate: true,
      async handler(customerId) {
        if (customerId && customerId !== 1) {
          await this.stGetCustomerRewardBalance(customerId)
        }
      },
    },
  },

  methods: {
    ...mapActions('pages/pdv/atm/status', {
      stSetIsCartOpen: 'setIsCartOpen',
    }),
    ...mapActions('pages/pdv/atm/catalog', {
      stSetFiltersAndSearch: 'setFiltersAndSearch',
    }),
    ...mapActions('reward', {
      stGetCustomerRewardBalance: 'getCustomerRewardBalance',
    }),

    onLogoClick() {
      this.stSetFiltersAndSearch(getInitialAtmCatalogFilters())
    },

    onShowCartSidebar() {
      this.stSetIsCartOpen(true)
    },
  },
}
</script>

<style lang="scss" scoped>
.brand-logo > img {
  box-sizing: border-box;
  width: 300px;
}

.customer-info {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cart-section {
  width: 300px;
  display: flex;
  justify-content: flex-end;
}

.reward-balance {
  .ecash-icon {
    width: 32px;
    height: 32px;
  }
}
</style>
